import {TableCell} from "@mui/material";
import {styled} from "@mui/system";

export const StyledContentTableHeader = styled(TableCell)(({ theme }) => ({
    padding: "6px 10px",
    textAlign: "left",
    fontSize: "0.75rem",
    lineHeight: "1.83rem",
    backgroundColor: "transparent",
    border: "none",
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
        fontSize: "0.35rem",
        padding: "2px 3px",
        maxWidth: "50px",
        wordWrap: "break-word",
        overflowWrap: "break-word",
        whiteSpace: "normal",
    },
}));

export const StyledContentTableCell = styled(TableCell)(({ theme }) => ({
    padding: "6px 10px",
    textAlign: "left",
    fontSize: "0.75rem",
    lineHeight: "1.83rem",
    backgroundColor: "#e6f7e6",
    border: "1px solid white",
    [theme.breakpoints.down("sm")]: {
        fontSize: "0.35rem",
        padding: "2px 3px",
    },
}));
